/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Maxdesc1Inputs */

const zh_plan_maxdesc1 = /** @type {(inputs: Plan_Maxdesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合团队和专业用户`)
};

const en_plan_maxdesc1 = /** @type {(inputs: Plan_Maxdesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For teams and professionals`)
};

const es_plan_maxdesc1 = /** @type {(inputs: Plan_Maxdesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para equipos y profesionales`)
};

/**
* | output |
* | --- |
* | "For teams and professionals" |
*
* @param {Plan_Maxdesc1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_maxdesc1 = /** @type {((inputs?: Plan_Maxdesc1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Maxdesc1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_maxdesc1(inputs)
	if (locale === "en") return en_plan_maxdesc1(inputs)
	return es_plan_maxdesc1(inputs)
});
export { plan_maxdesc1 as "plan_maxDesc" }